import { createSelector } from 'reselect';
import get from 'lodash/get';

export const selectRootState = state => get(state, 'paymentMethods');

export const selectOrganizationList = createSelector(
  selectRootState,
  state => get(state, 'organizationList.list', []),
);

export const selectLocationList = createSelector(
  selectRootState,
  state => get(state, 'locationList.list', []),
);

export const selectLocationListIsFetching = createSelector(
  selectRootState,
  state => get(state, 'locationList.sending', false),
);

export const selectPaymentList = createSelector(
  selectRootState,
  state => get(state, 'paymentList.list', []),
);

export const selectIsPaymentListFetching = createSelector(
  selectRootState,
  state => get(state, 'paymentList.sending', false),
);

export const selectAccountVaultsLocationsByAccountVaultId = accountVaultId => {
  return createSelector(
    selectPaymentList,
    paymentList => {
      const accountVaultItem = paymentList
        .flatMap(x => x.accountvaults)
        .find(({ accountvault }) => accountvault.id === accountVaultId);

      return get(accountVaultItem, 'associatedLocations', []);
    },
  );
};



// WEBPACK FOOTER //
// ./src/redux/payment-methods/selectors.js